import EarnSVG from "../assets/earn/earn.svg";
import styles from "./Earn.module.scss";
import ArrowSVG from "../assets/arrow-up-right-light.svg";

export const Earn = () => {
  return (
    <div className={styles.earn}>
      <div className={styles.background} />
      <div className={styles.container}>
        <div className={styles.title}>
          <img src={EarnSVG} alt="Earn" height="80px" />
          <div>
            <h2>
              <span className={`gradient ${styles.bold}`}>Earn</span> with HFT
            </h2>
          </div>
        </div>
        <div className={styles.content}>
          <h6>Stake & Earn</h6>
          <p>
            Stake HFT <br />
            to earn rewards
          </p>
          <div className={styles.link}>
            <a
              href="https://app.hashflow.com/stake"
              target="_blank"
              rel="noreferrer"
            >
              Get started
            </a>
            <img src={ArrowSVG} alt="Arrow" />
          </div>
        </div>
        <div className={styles.content}>
          <h6>Governance</h6>
          <p>
            Shape the future <br />
            of Hashflow
          </p>
          <div className={styles.link}>
            <a
              href="https://gov.hashflow.com/"
              target="_blank"
              rel="noreferrer"
            >
              Explore now
            </a>
            <img src={ArrowSVG} alt="Arrow" />
          </div>
        </div>
      </div>
    </div>
  );
};
